import useHasAccessSharingPermissions from './useHasAccessSharingPermissions';
export default useHasAccessSharingPermissions;
